import React from "react";

import { Button, Container } from "react-bootstrap";

import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { ROUTES } from "src/routes";

import FooterImg from "@assets/Images/FooterImg.jpg";
import logoSingleColour from "@assets/rrs-logo-single-colour.svg";

import styles from "./PublicFooter.module.scss";

export const PublicFooter = () => {
  return (
    <footer className={styles["root-container"]}>
      <Container fluid>
        <div className="d-flex flex-column flex-md-row justify-content-between">
          <Link to={ROUTES.Root.path}>
            <ReactSVG className={styles["logo"]} src={logoSingleColour}></ReactSVG>
          </Link>

          <div className="d-flex gap-5 pt-5 pt-md-0">
            <Button variant="plain" className={styles["footer-links"]} role="link">
              <Link to="https://www.copyright.com.au/membership/join-us/" className="text-white b4 bold">
                Copyright Agency Membership
              </Link>
            </Button>
            <Button variant="plain" className={styles["footer-links"]} role="link">
              <Link to="https://www.copyright.com.au/privacy/" className="text-white b4 bold">
                Privacy
              </Link>
            </Button>
            <Button variant="plain" className={styles["footer-links"]} role="link">
              <Link to="https://www.copyright.com.au/about-us/" className="text-white b4 bold">
                About Copyright Agency
              </Link>
            </Button>
          </div>
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-between pt-5 mt-4">
          <div className="col-md-7 b4 medium">
            <p>
              We acknowledge the Traditional Custodians on whose land our office stands: the Gadigal of the Eora nation.
              We value their heritage, beliefs and relationship with the land, which are often expressed through art.
            </p>
            <p> We pay our respects to their Elders past and present.</p>
          </div>
          <div className="col-md-2 pt-5 pt-md-0">
            <div className="b3 bold">Newsletter</div>
            <div className="b4 medium pt-2">Sign up for resale royalty news</div>
            <Button variant="secondary" className="mt-4">
              {" "}
              <Link to="https://info.copyright.com.au/l/348061/2024-11-10/4gg9kzx">Sign up today</Link>
            </Button>
          </div>
        </div>
        <div className="d-flex gap-5 align-items-center pt-5 pt-md-0">
          <img src={FooterImg} />
          <div className="b4 medium">
            The Australian Government has appointed Copyright Agency to manage the resale royalty scheme.
          </div>
        </div>
        <div className="pt-5 mt-5 b5 medium monoGrey4 text-center w-100">
          © Copyright Agency Limited and contributors 2024. ABN 53 001 228 799
        </div>
      </Container>
    </footer>
  );
};
